/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Picker_Hint_Single_VideoInputs */

const vi_media_picker_hint_single_video = /** @type {(inputs: Media_Picker_Hint_Single_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm một video để chọn, hoặc Tải lên video MP4 mới từ máy.`)
};

/**

* @param {Media_Picker_Hint_Single_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_picker_hint_single_video = /** @type {((inputs?: Media_Picker_Hint_Single_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Picker_Hint_Single_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_picker_hint_single_video(inputs)
});